import { categoryIndexValidate } from '../../application/dtos/category_index_validate';

export class categoryIndexEntity {
    constructor( { id, name, description } ){
        this.id = id;
        this.name = name;
        this.description = description;
    }

    isValid() {
        return categoryIndexValidate(this);
    }
}